import React from 'react';

import { ISmartProps as ISmartPropsSttFull } from './typesStateful';
import { StatefulPopover as StatefulView } from './viewStateful';
import { ISmartProps } from './typesStateless';
import { StatelessPopover as StatelessView } from './viewStateless';
import { AccessibilityType as _ACCESSIBILITY_TYPE } from './typesStateless';
import { TriggerType as _TRIGGER_TYPE } from './typesStateless';
import { TetherPlacement as _TETHER_PLACEMENT } from './typesStateless';

export type StatefulPopoverProps = ISmartPropsSttFull;
export type PopoverProps = Omit<ISmartProps, 'css'>;

export type ACCESSIBILITY_TYPE = _ACCESSIBILITY_TYPE;
export type TRIGGER_TYPE = _TRIGGER_TYPE;
export type TETHER_PLACEMENT = _TETHER_PLACEMENT;

export const StatefulPopover = React.forwardRef((props: any, ref: any) => <StatefulView {...props} ref={ref} />);
export const Popover = React.forwardRef(StatelessView);
